<a mat-raised-button [ngClass]="gameTenantKind === 'Company' ? 'company-bg' : 'school-bg'" [routerLink]="routerLink">
  <ng-content></ng-content>
</a>
